import { useTranslation } from 'react-i18next';
import { getSupportArticleLink } from "../utils/common";
export var useHelpCenterUrl = function useHelpCenterUrl(id) {
  var _useTranslation = useTranslation(),
      i18n = _useTranslation.i18n;

  return getSupportArticleLink(i18n.resolvedLanguage, id);
};